'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './search-result.routes';

export class SearchResultComponent {
  constructor($stateParams, Auth, dialogs, $uibModal, PropertyService, CommunityService, ContactService,
              WorkOrderTicketsService, ViolationTicketsService, ServiceRequestTicketsService, VendorService) {
    'ngInject';
    this.searchterm = $stateParams.searchterm;
    this.type = $stateParams.type;
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.Auth = Auth;

    this.found = {
      communities: [],
      properties: [],
      contacts: [],
      vendors: [],
      workOrders: [],
      violations: [],
      serviceRequests: []
    };

    CommunityService.query(data => this.found.communities = data.filter(cmty => JSON.stringify(cmty).toLowerCase().indexOf(this.searchterm.toLowerCase()) != -1));
    PropertyService.query(data => this.found.properties = data.filter(prop => JSON.stringify(prop).toLowerCase().indexOf(this.searchterm.toLowerCase()) != -1));
    ContactService.query(data => this.found.contacts = data.filter(contact => JSON.stringify(contact).toLowerCase().indexOf(this.searchterm.toLowerCase()) != -1));
    VendorService.query(data => this.found.vendors = data.filter(vendor => JSON.stringify(vendor).toLowerCase().indexOf(this.searchterm.toLowerCase()) != -1));
    WorkOrderTicketsService.query(data => this.found.workOrders = data.filter(wo => JSON.stringify(wo).toLowerCase().indexOf(this.searchterm.toLowerCase()) != -1));
    ServiceRequestTicketsService.query(data => this.found.serviceRequests = data.filter(sr => JSON.stringify(sr).toLowerCase().indexOf(this.searchterm.toLowerCase()) != -1));
    ViolationTicketsService.query(data => this.found.violations = data.filter(ccr => JSON.stringify(ccr).toLowerCase().indexOf(this.searchterm.toLowerCase()) != -1));
  }

  getPlaintext(html) {
    return (html) ? html.replace(/<[^>]+>/gm, ' ').substr(0,120) : "";
  }

}

export default angular.module('conduu.searchResult', [uiRouter])
  .config(routes)
  .component('searchResult', {
    template: require('./search-result.html'),
    controller: SearchResultComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/search/result/search-result.component.js